// extracted by mini-css-extract-plugin
module.exports = {"registration":"styles_registration__3aS5C"};